<template>
  <div id="container">
    <!-- 此处放置el-tabs代码 -->
    <el-tabs
      v-model="activeIndex"
      type="border-card"
      closable
      v-if="openTab.length"
      @tab-click="tabClick"
      @tab-remove="tabRemove"
    >
      <el-tab-pane
        :key="item.name"
        v-for="item in openTab"
        :label="item.name"
        :name="item.route"
      >
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Bus from "@/utils/bus.js";
export default {
  data() {
    return {};
  },

  components: {},

  created() {},
  methods: {
    //tab标签点击时，切换相应的路由
    tabClick(tab) {
      this.$router.push({ path: this.activeIndex });
    },
    //移除tab标签
    tabRemove(targetName) {
      console.log("tabRemove", targetName);
      //首页不删
      // if(targetName == '/'||targetName == '/home'){
      //   return
      // }
      this.$store.commit("delete_tabs", targetName);
      if (this.activeIndex === targetName) {
        // 设置当前激活的路由
        if (this.openTab && this.openTab.length >= 1) {
          console.log(
            "=============",
            this.openTab[this.openTab.length - 1].route
          );
          this.$store.commit(
            "set_active_index",
            this.openTab[this.openTab.length - 1].route
          );
          this.$router.push({ path: this.activeIndex });
        } else {
          this.$router.push({ path: "/" });
        }
      }
    },
  },
  mounted() {
    // 页面刷新时以当前路由做为tab加入tabs
    // 当前路由不是首页时，添加首页以及另一页到store里，并设置激活状态
    // 当当前路由是首页时，添加首页到store，并设置激活状态

    console.log("222", this.$route.meta.title);

    if (this.$route.fullPath !== "/" && this.$route.fullPath !== "/home") {
      // this.$store.commit('add_tabs', {route: '/home' , name: '首页'});
      // this.$store.commit('add_tabs', {route: this.$route.path , name: this.$route.name });
      this.$store.commit("set_active_index", this.$route.fullPath);
    } else {
      this.$store.commit("delete_tabs", "/home");

      this.$store.commit("add_tabs", { route: "/home", name: "首页" });
      this.$store.commit("set_active_index", "/home");
      this.$router.push("/");
    }
  },
  computed: {
    openTab() {
      if (!this.$store.state.openTab.length) {
        this.$store.commit("add_tabs", {
          route: this.$route.fullPath,
          name: this.$route.meta.title,
        });
      }
      return this.$store.state.openTab;
    },
    activeIndex: {
      get() {
        return this.$store.state.activeIndex;
      },
      set(val) {
        var set_active_name = "";
        if (this.openTab && this.openTab.length > 0 && val) {
          this.openTab.forEach((item) => {
            if (item.route == val) {
              set_active_name = item.name;
            }
          });
        } else {
          set_active_name = "";
        }
        if (set_active_name) {
          console.log("set_active_name", set_active_name);
          // localStorage.setItem("set_active_name", set_active_name);
          Bus.$emit("set_active_name", set_active_name);
        }

        this.$store.commit("set_active_index", val);
      },
    },
  },
  watch: {
    $route(to, from) {
      //判断路由是否已经打开
      //已经打开的 ，将其置为active
      //未打开的，将其放入队列里
      let flag = false;
      for (let item of this.openTab) {
        // console.log("111", item.name, "t0.name", to.name, "to", to);

        if (item.name === to.meta.title) {
          let routeTabs = this.$store.state.openTab;
          routeTabs.forEach((item1, index1) => {
            if (item1.name == to.meta.title && item1.route !== to.fullPath) {
              this.$store.state.openTab[index1].route = to.fullPath;
              // console.log("item1,我是变化的相同路由", item1);
            }
          });

          this.$store.commit("set_active_index", to.fullPath);
          flag = true;
          break;
        }
      }

      if (!flag) {
        this.$store.commit("add_tabs", {
          route: to.fullPath,
          name: to.meta.title,
        });
        this.$store.commit("set_active_index", to.fullPath);
      }
    },
  },
};
</script>

<style scoped lang="less">
* {
  box-sizing: border-box;
}
/deep/ .el-tabs--border-card > .el-tabs__content {
  padding: 0;
  margin: 0;
}
#container {
  height: 45px;
  /deep/ .el-tabs__item {
    font-size: 14px;
    height: 45px;
    margin: 0px 5px 0px 0px;
    line-height: 45px;
    color: #191b27;
    padding: 0 38px;
    // border: 1px solid #42b983;
    // border-radius: 5px;
  }
}
/deep/ .el-tabs__item:hover {
  color: #42b983;
}
/deep/ .el-tabs--border-card > .el-tabs__header {
  background-color: #fff;
}
/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #846ffd1f;
  border-bottom: 3px solid #846ffd;
  color: #fff;
}
/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active:hover {
  color: #fff;
}
/deep/ .el-tabs__item .el-icon-close {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #999fb5;
}
/deep/ .el-tabs__item .el-icon-close:hover {
  background-color: #fff;
  color: #ccc;
}
</style>
